import React, { useMemo } from 'react'
import { createColumnHelper } from '@tanstack/react-table'
import { Box } from '@mui/material'

import { useGetC2BQrs } from '@/services'
import { C2BQr } from '@/types.ts'
import { TableComponent } from '@/components/table'
import { FetchErrorMessage } from '@/components'
import { useIsMobile } from '@/hooks'
import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import { c2bActions, c2bSelectors } from '@/stores/slices/c2b-slice.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'

import { defaultSettings, getColumnsSettings, KEY_PAGE, PartialC2BQr } from '../default-settings-c2b-page.tsx'
import { DefaultFiltersState } from '@/stores'

const columnHelper = createColumnHelper<C2BQr>()

const defaultColumns = getColumnsSettings(columnHelper)

export const C2BQrsTable = (): React.ReactElement => {
  const { data, isLoading, isFetching, isError, refetch } = useGetC2BQrs()
  const { page, showCount } = useAppSelector(c2bSelectors.filters)
  const dispatch = useAppDispatch()
  const settings = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE))
  const isMobile = useIsMobile()

  const handlePaginationParam = (param: keyof DefaultFiltersState) => (value: number) =>
    dispatch(
      c2bActions.setFilter({
        filterKey: param,
        filterValue: value,
      })
    )

  const qrsC2BCols = useMemo(() => {
    const format = isMobile ? 'mobile' : 'desktop'

    const desktopSettings = (settings?.[format] ?? Object.keys(defaultSettings)) as Array<keyof PartialC2BQr>

    const dynamicSettings = desktopSettings.map((e) => defaultColumns[e])
    return [...dynamicSettings]
  }, [settings, isMobile])
  return (
    <FetchErrorMessage refetch={refetch} isFetching={isFetching} isError={isError}>
      <Box mt={3}>
        <TableComponent<C2BQr>
          rowKey="requestId"
          columns={qrsC2BCols}
          page={page}
          isLoading={isLoading || isFetching}
          size={showCount}
          data={data?.data?.content ?? []}
          totalPages={data?.data?.totalPages}
          onPageChange={handlePaginationParam('page')}
          onSizeChange={handlePaginationParam('showCount')}
        />
      </Box>
    </FetchErrorMessage>
  )
}
